/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'dollars': {
    width: 16,
    height: 16,
    viewBox: '0 0 256 256',
    data: '<path pid="0" d="M100.3 60.8h94.1V33.9h-53.8V7h-26.9v26.9h-13.4C78.1 33.9 60 52 60 74.2v26.9c0 22.2 18.1 40.3 40.3 40.3h53.8c7.4 0 13.4 6 13.4 13.4v26.9c0 7.4-6 13.4-13.4 13.4H60V222h53.8v27h26.9v-26.9h13.4c22.2 0 40.3-18.1 40.3-40.3v-26.9c0-22.2-18.1-40.3-40.3-40.3h-53.8c-7.4 0-13.4-6-13.4-13.4v-27c0-7.4 6-13.4 13.4-13.4z"/>'
  }
})
